import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigation } from 'react-router';
import { usePageNavigate } from './navigation';
import { AppShell } from '../components/shell/AppShell';
import { useThemeStore } from './theme';

export const ShellLayout: React.FC = () => {
  const location = useLocation();
  const navigate = usePageNavigate();
  const navigation = useNavigation();
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    void useThemeStore.persist.rehydrate();
    document.documentElement.dataset.sladReady = 'true';
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme === 'system' ? '' : theme;
  }, [theme]);

  return (
    <AppShell
      activePath={location.pathname}
      onNavigate={(p) => {
        void navigate(p);
      }}
    >
      {navigation.state !== 'idle' && (
        <div className="sedlex-navigation-status" role="status" aria-live="polite">
          <span className="sedlex-loading-dot" aria-hidden="true" /> Loading view…
        </div>
      )}
      <Outlet />
    </AppShell>
  );
};
